import {useState, useEffect} from 'react'
import ProfileService from '../services/ProfileService';

const useCheckInterestAndExpertise = () => {
    const [isInterestEmpty, setIsInterestEmpty] = useState(false);

    useEffect(() => {
        validateInterestsAndExpertise();
      }, [isInterestEmpty]);

    const validateInterestsAndExpertise = async() =>{
        const data = await ProfileService.getInterests();
        if(data.userInterestList && !data.userInterestList.length ){
        setIsInterestEmpty(true);
        }
      }

      return isInterestEmpty;
 
}

export default useCheckInterestAndExpertise